import { render, staticRenderFns } from "./DispensationCalendarTab.vue?vue&type=template&id=6aa707ac&scoped=true&"
import script from "./DispensationCalendarTab.vue?vue&type=script&lang=ts&"
export * from "./DispensationCalendarTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa707ac",
  null
  
)

export default component.exports